<template>
  <div class="learn-home">
    <div class="container">
      <div class="row">
        <div style="display: flex" class="links mb-4">
          <span style="font-weight: bold; font-size: 4rem">
            <img
              style="width: 100px"
              src="@/assets/svg/Ardunic Elements-26.svg"
              alt
            />
            Tags
          </span>
        </div>
      </div>
      <div class="row">
        <span v-for="tag in tags" :key="tag._id" style="margin: 7px 4px">
          <span
            :style="
              `font-size: 1.1rem; cursor: pointer; display: initial;color: white;height:20px;background:${
                tag.color
              }`
            "
            class="badge"
            @click="navigateTga(tag._id)"
            >#{{ tag.name }}</span
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import axios from "axios";
export default {
  data() {
    return {
      taggs: {
        deta: [],
      },
      colors: [
        { first: "#ff0400", second: "#ffcf69" },
        { first: "#c7f1ff", second: "#00d6ff" },
        { first: "#02b718", second: "#00d6ff" },
        { first: "#f16522", second: "#ffcf69" },
        { first: "#ff2cc6", second: "#ffcf69" },
      ],
    };
  },
  computed: {
    tags() {
      return this.taggs.deta.map((tag) => {
        const colors = [
          "linear-gradient(90deg, #00E5FF 0%, #02B718 100%);",
          "linear-gradient(90deg, #40C012 0%, #AAF064 100%);",
          "linear-gradient(90deg, #EB3D3D 0%, #FC965C 100%);",
          "linear-gradient(90deg, #3DEBAC 0%, #5CFCF2 100%);",
          "linear-gradient(90deg, #DDB54D 0%, #E5F064 100%);",
          "linear-gradient(90deg, #0047FF 0%, #31CAFB 100%);",
        ];

        return {
          ...tag,
          color: colors[Math.floor(Math.random() * (5 - 0) + 0)],
        };
      });
    },
  },
  created() {
    this.getTags();
  },
  methods: {
    getTags() {
      axios
        .get(`https://api.ardunic.com/v1/tags?p=1&s=20`)
        .then((res) => (this.taggs.deta = res.data.data));
    },
    navigateTga(id) {
      router.push({ path: `/tag/${id}` });
      // console.log(slug);
    },
  },
};
</script>

<style>
.learn-home {
  margin-top: 90px;
}
</style>
